import { Controller } from "@hotwired/stimulus"

// Tri-état par inscrit du formulaire de dépôt d'une feuille d'émargement papier.
//
// Les radios visibles (présent / absent / non traité) ne sont PAS les champs
// soumis : SessionSlot::PaperSheetIngestion attend exactement deux tableaux
// d'ids (`present_user_ids[]`, `absent_user_ids[]`). Le controller miroite donc
// l'état de chaque ligne dans deux inputs cachés en jouant sur `disabled` — un
// champ désactivé n'est pas envoyé, ce qui matérialise le 3e état « non traité »
// (aucune présence créée pour cet inscrit).
//
// Aucun listener document/window ni instance de librairie n'est posé en
// connect() : il n'y a rien à démonter, donc pas de disconnect() à écrire
// (règle « cleanup symétrique » du CLAUDE.md).
//
// Câblage (voir attendances/_paper_sheet_panel.html.erb) :
//   data-controller="paper-sheet-roster"
//   data-action="change->paper-sheet-roster#sync"
//   data-paper-sheet-roster-counter-template-value="<%= t('...counter') %>"
//   data-paper-sheet-roster-target="row" sur chaque ligne d'inscrit
export default class extends Controller {
  static targets = [ "row", "counter" ]

  static values = {
    counterTemplate: { type: String, default: "%{present} présent(s), %{absent} absent(s)" }
  }

  connect() {
    this.sync()
  }

  // Recalcule les champs soumis et le compteur à chaque changement d'état.
  sync() {
    let presentCount = 0
    let absentCount = 0

    this.rowTargets.forEach((row) => {
      const state = this.stateOf(row)
      this.toggleField(row, "present_user_ids[]", state === "present")
      this.toggleField(row, "absent_user_ids[]", state === "absent")
      if (state === "present") presentCount += 1
      if (state === "absent") absentCount += 1
    })

    this.renderCounter(presentCount, absentCount)
  }

  // Positionne toutes les lignes sur le même état (data-*-state-param).
  markAll(event) {
    event.preventDefault()
    const state = event.params.state

    this.rowTargets.forEach((row) => {
      const radio = row.querySelector(`input[type="radio"][value="${state}"]`)
      if (radio) radio.checked = true
    })

    this.sync()
  }

  stateOf(row) {
    const checkedRadio = row.querySelector('input[type="radio"]:checked')
    return checkedRadio ? checkedRadio.value : "skipped"
  }

  toggleField(row, fieldName, enabled) {
    const field = row.querySelector(`input[name="${fieldName}"]`)
    if (!field) return

    field.disabled = !enabled
  }

  renderCounter(presentCount, absentCount) {
    if (!this.hasCounterTarget) return

    this.counterTarget.textContent = this.counterTemplateValue
      .replace("%{present}", presentCount)
      .replace("%{absent}", absentCount)
  }
}
